import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Empty, Pagination } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchBox from "../../../components/SearchBox";
import config from "../../../config";
import User from "../../../assets/img/icons/user3.png";
import EmployeeAssetsDetail from "./EmployeeAssetsDetail";
import { companyID, getEmployeeLocalDetails } from "../../../auth";
import EmployeeMultiSelect from "../../../components/EmployeeMultiSelect";
import { useEmployees } from "../../../hooks/useEmployees";
import AssignAssetModel from "../../../components/AssignAssetModel";
import AddAssetModel from "../../../components/AddAssetModel";
import AssetDetails from "./AssetDetails";
import api from "../../../api/axios";
import { getDepartmentById } from "../../../services/departmentService";
import FilterComponent from "../../../components/FilterComponent";
import TooltipWrapper from "../../../utils/TooltipWrapper";

const AssetAssignment = () => {
  const loginEmployeeDetails = getEmployeeLocalDetails();
  const location = useLocation();
  const [showAssetDetail, setShowAssetDetail] = useState(false);
  const [employeeAssetDetails, setEmployeeAssetDetails] = useState([]);
  const [selectedEmployeeDetail, setSelectedEmployeeDetail] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showCompanyAssets, setShowCompanyAssets] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(12);
  const detail = {
    selectedDate: null,
    selectedAssetType: "",
    serialNumber: "",
    modelNumber: "",
    manufacturer: "",
    warranty: "",
    original_price: "",
    current_price: "",
  };
  const [assetDetails, setAssetDetails] = useState(detail);
  const [assetModel, setAssetModel] = useState({
    title: "Add",
    buttonText: "Add",
  });
  const [filterOptions, setFilterOptions] = useState([
    { key: "Active", label: "status", value: [1], category: "Status" },
    { key: "Inactive", label: "status", value: [0], category: "Status" },
    { key: "All Employees", label: "status", value: null, category: "Status" },
  ]);

  // Employee selection state (UI only)
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const { options: employeeOptions, loading: loadingEmployees } = useEmployees({status: 1});

  const uniqueEmployees = React.useMemo(() => {
    const map = new Map();

    employeeAssetDetails.forEach((item) => {
      if (!map.has(item.employee_id)) {
        map.set(item.employee_id, item);
      }
    });

    return Array.from(map.values());
  }, [employeeAssetDetails]);

  useEffect(() => {
    setCurrentPage(1);
  }, [uniqueEmployees.length]);

  const navigate = useNavigate();

  const startIndex = (currentPage - 1) * paginationValue;
  const endIndex = startIndex + paginationValue;
  const selectedDetails = uniqueEmployees.slice(startIndex, endIndex);
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPaginationValue(pageSize);
  };

  //   const user = localStorage.getItem("user");
  //   let department_id;
  //     if(user){
  //       const companyDetails = JSON.parse(user);
  //       department_id = companyDetails.department_id
  //     }
  const company_id = companyID();

  useEffect(() => {
    const targetEmployeeId = location.state?.employeeId;
    if (location.state?.showAssetDetail && targetEmployeeId) {
      setShowAssetDetail(true);
      setSelectedEmployee(targetEmployeeId);
    }
  }, [location.state]);



  const fetchEmployeesAssets = (params = { status: 1 }) => {
    if (
      !loginEmployeeDetails ||
      !loginEmployeeDetails.employee_role ||
      (loginEmployeeDetails.employee_role != 1 &&
        !loginEmployeeDetails.working_departments?.length)
    ) {
      setEmployeeDetails([]);
      setEmployeeAssetDetails([]);
      return;
    }

    let finalParams = { ...params };

    if (
      loginEmployeeDetails.employee_role != 1 &&
      loginEmployeeDetails.working_departments?.length
    ) {
      if (!("department_id" in finalParams))
        finalParams.department_id = loginEmployeeDetails.working_departments;
    }

    const queryParams = new URLSearchParams();
    Object.entries(finalParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          if (val !== null && val !== undefined && val !== "") {
            queryParams.append(key, val);
          }
        });
      } else {
        queryParams.append(key, value);
      }
    });

    api
      .get(`employee-assets/${company_id}?${queryParams.toString()}`)
      .then((res) => {
        setEmployeeAssetDetails(res.data.data);

        setEmployeeDetails(res.data.data);
      })
      .catch((err) => {
        console.error(err);
        setEmployeeDetails([]);
        setEmployeeAssetDetails([]);
      })
      .finally(() => {
        //loader
      });
  };

  const fetchDepartments = async () => {
    try {
      const departments = await getDepartmentById(company_id);
      if (!departments?.result?.length) {
        return;
      }
      const mappedDepartments = departments.result
        .filter((dept) => {
          if (
            loginEmployeeDetails.employee_role != 1 &&
            loginEmployeeDetails.working_departments?.length
          ) {
            return loginEmployeeDetails?.working_departments?.includes(dept.id);
          } else if (loginEmployeeDetails.employee_role == 1) {
            return true;
          } else {
            return false;
          }
        })
        .map((dept) => ({
          key: dept.department_name,
          label: "department_id",
          value: dept.id,
          category: "Department",
        }));

      setFilterOptions((prevOptions) => [...prevOptions, ...mappedDepartments]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  useEffect(() => {
    fetchDepartments();
  }, []);

  // Selection logic handled by EmployeeMultiSelect

  // Employee fetching handled by useEmployees hook

  useEffect(() => {
    if (selectedEmployeeIds.length > 0) {
      fetchEmployeesAssets({ status: 1, employee_id: selectedEmployeeIds });
    } else {
      fetchEmployeesAssets({ status: 1 });
    }
  }, [selectedEmployeeIds]);

  useEffect(() => {
    if (company_id) {
      fetchEmployeesAssets();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (!selectedEmployee) {
      return;
    }
    const employeeAssets = employeeAssetDetails.filter(
      (asset) => asset.employee_id === selectedEmployee
    );

    setSelectedEmployeeDetail(employeeAssets);
  }, [employeeAssetDetails, selectedEmployee]);

  const getNameOfEmployee = () => {
    if (selectedEmployeeDetail.length > 0) {
      const middle_name = selectedEmployeeDetail[0].middle_name
        ? selectedEmployeeDetail[0].middle_name + " "
        : "";
      return (
        selectedEmployeeDetail[0].first_name +
        " " +
        middle_name +
        selectedEmployeeDetail[0].last_name
      );
    }
    return "Employee";
  };

  // function createEmployeeMap(employees) {
  //   const employeeMap = new Map();
  //   employees.forEach((employee) => {
  //     if (!employeeMap.has(employee.employee_id)) {
  //       employeeMap.set(employee.employee_id, []);
  //     }
  //     employeeMap.get(employee.employee_id).push(employee);
  //   });
  //   return employeeMap;
  // }

  // function getEmployeeDataById(employeeMap, employee_id) {
  //   return employeeMap.get(employee_id) || [];
  // }

  // const filterSelectedEmployeeDetail = (selectedEmployee, employeeId) => {
  //   // const employeeMap = createEmployeeMap(selectedEmployee);
  //   // const employeeData = getEmployeeDataById(employeeMap, employeeId);

  //   return employeeData;
  // };

  useEffect(() => {
    getNameOfEmployee();
  }, [selectedEmployeeDetail]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const openAddAssetModal = () => {
    setIsAddModalOpen(true);
  };

  useEffect(() => {
    if (isModalOpen || isAddModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [isModalOpen, isAddModalOpen]);

  // const fetchSelectedEmployeeData = (selectedEmployee) => {
  //   const employeeData = filterSelectedEmployeeDetail(
  //     employeeDetails,
  //     selectedEmployee
  //   );
  //   setSelectedEmployeeDetail(employeeData);
  // };

  // useEffect(() => {
  //   if (selectedEmployee) {
  //     fetchSelectedEmployeeData(selectedEmployee);
  //   }
  // }, [isModalOpen, employeeDetails]);

  const openEmployeeDetail = (e, detail) => {
    e.preventDefault();
    setShowAssetDetail(true);
    setSelectedEmployee(detail.employee_id);

    const employeeAssets = employeeAssetDetails.filter(
      (asset) => asset.employee_id === detail.employee_id
    );

    setSelectedEmployeeDetail(employeeAssets);
  };

  return (
    <div>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={
              showCompanyAssets
                ? "Company Assets"
                : showAssetDetail
                  ? `${getNameOfEmployee()} Assets Details`
                  : "Employees Assets"
            }
            title={
              showAssetDetail || showCompanyAssets
                ? "Employees Assets"
                : "Dashboard"
            }
            subtitle={
              showCompanyAssets
                ? "Company Assets"
                : showAssetDetail
                  ? getNameOfEmployee()
                  : "Employees Assets"
            }
            titleLink={
              showAssetDetail || showCompanyAssets ? "asset-assignment" : null
            }
            name={showCompanyAssets ? "Add asset" : "Assign asset"}
            openModal={showCompanyAssets ? openAddAssetModal : openModal}
            page="asset-assignment"
            action="create"
            onBackButton={() => {
              showAssetDetail
                ? setShowAssetDetail(false)
                : showCompanyAssets
                  ? setShowCompanyAssets(false)
                  : navigate(-1);
            }}
          />
          {!showAssetDetail && !showCompanyAssets ? (
            <div className="d-flex justify-content-between">
              <div className="flex-grow-1">
                <SearchBox setPaginationValue={setPaginationValue} />
              </div>
              <div className="d-flex justify-content-end mb-2 gap-2">
                {/* Employee Search Dropdown */}
                <div style={{ width: "250px", position: "relative" }}>
                  <EmployeeMultiSelect
                    options={employeeOptions}
                    selectedValues={selectedEmployeeIds}
                    onChange={setSelectedEmployeeIds}
                    loading={loadingEmployees}
                  />
                </div>

                {/* <button className="btn btn-link" onClick={()=>setIsAddModalOpen(true)}>Add Asset</button> */}
                <button
                  className="btn text-white me-2"
                  style={{ backgroundColor: "var(--company-theme)" }}
                  onClick={() => setShowCompanyAssets(true)}
                >
                  Company Assets
                </button>
                <TooltipWrapper tooltipText="Filter">
                  <FilterComponent
                    filterOptions={filterOptions}
                    onApplyFilter={(selectedFilter) => {
                      const queryParams = Object.entries(selectedFilter)?.length
                        ? selectedFilter
                        : { status: 1 };
                      fetchEmployeesAssets(queryParams);
                    }}
                    filterLabel="Filter Employees"
                    resetLabel="Reset Filter"
                    applyLabel="Apply"
                  />
                </TooltipWrapper>
              </div>
            </div>
          ) : (
            <></>
          )}
          {showCompanyAssets ? (
            <AssetDetails
              setShowCompanyAssets={setShowCompanyAssets}
              setIsAddModalOpen={setIsAddModalOpen}
              setAssetDetails={setAssetDetails}
              setAssetModel={setAssetModel}
              isAddModalOpen={isAddModalOpen}
            />
          ) : !showAssetDetail ? (
            <>
              <div className="row">
                {uniqueEmployees.length === 0 ? (
                  <Empty description="No Assets details available." />
                ) : (
                  selectedDetails.map((detail) => (
                    <div
                      className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                      key={detail.id}
                    >
                      <div className="profile-widget">
                        <div className="profile-img">
                          <Link
                            to="#"
                            className="avatar"
                            onClick={(e) => openEmployeeDetail(e, detail)}
                          >
                            <img
                              src={
                                detail?.photo
                                  ? `${config.IMAGE_URL}${detail.photo}`
                                  : User
                              }
                              alt=""
                            />
                          </Link>
                        </div>
                        <h4 className="user-name m-t-10 mb-0 text-ellipsis">
                          <Link
                            to="#"
                            onClick={(e) => openEmployeeDetail(e, detail)}
                          >
                            {detail?.first_name} {detail?.middle_name}{" "}
                            {detail?.last_name}
                          </Link>
                        </h4>
                        <div className="small text-muted">
                          {detail?.designation_name
                            ? detail?.designation_name
                            : ""}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="d-flex justify-content-end mb-4">
                <Pagination
                  current={currentPage}
                  pageSize={paginationValue}
                  total={uniqueEmployees.length}
                  onChange={handlePageChange}
                  showSizeChanger={true}
                  pageSizeOptions={[4, 8, 12, 16, 20, 24]}
                  showLessItems={true}
                />
              </div>{" "}
            </>
          ) : (
            <EmployeeAssetsDetail
              selectedEmployeeDetail={selectedEmployeeDetail}
              setShowAssetDetail={setShowAssetDetail}
              fetchEmployeesAssets={fetchEmployeesAssets}
            />
          )}
        </div>
      </div>
      <AssignAssetModel
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
      <AddAssetModel
        assetModel={assetModel}
        setAssetModel={setAssetModel}
        setIsAddModalOpen={setIsAddModalOpen}
        isAddModalOpen={isAddModalOpen}
        assetDetails={assetDetails}
        setAssetDetails={setAssetDetails}
        detail={detail}
      />
      {(isModalOpen || isAddModalOpen) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
};

export default AssetAssignment;
